/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTemperatureFahrenheit = createReactComponent("outline", "temperature-fahrenheit", "IconTemperatureFahrenheit", [["path", { "d": "M6 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-0" }], ["path", { "d": "M13 12l5 0", "key": "svg-1" }], ["path", { "d": "M20 6h-6a1 1 0 0 0 -1 1v11", "key": "svg-2" }]]);

export { IconTemperatureFahrenheit as default };
//# sourceMappingURL=IconTemperatureFahrenheit.mjs.map
